/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import backBoost from '../../../../assets/images/back-icon-boost.png';
import backFire from '../../../../assets/images/back-icon-fire.png';
import glassFire from '../../../../assets/images/back-icon-glass-fire.png';
import glassIsotipo from '../../../../assets/images/back-icon-glass-isotipo.png';
import glassUpgrade from '../../../../assets/images/back-icon-glass-upgrade.png';
import backIsotipo from '../../../../assets/images/back-icon-isotipo.png';
import backUpgrade from '../../../../assets/images/back-icon-upgrade.png';
import Button from '../../../../assets/styles/Button';
import Text from '../../../../assets/styles/Text';
import Loader from '../../../../components/Loader';
import ModelService from '../../../../services/ModelService';
import UpgradesService from '../../../../services/UpgradesService';
import { useStore } from '../../../../stores';
import formatFullDate from '../../../../utils/formatFullDate';
import formatHoursDate from '../../../../utils/formatHoursDate';
import * as styles from './styles';

export default function Plans({ show }) {
  const [loading, setLoading] = useState(true);
  const [model, setModel] = useState({});

  const user = useStore((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    async function loadPlanUpgradeAndFire() {
      try {
        setLoading(true);

        const getModel = await ModelService.findPlanModel(user.id);
        console.log(getModel);

        setModel(getModel);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }

    loadPlanUpgradeAndFire();
  }, [user]);

  const upgradeActive = useMemo(
    () =>
      model?.modelUpgrade?.filter(
        (upg) => upg.status === 'active' && upg?.upgrade?.type === 2
      ),
    [model]
  );

  const upgradeInactive = useMemo(
    () =>
      model?.modelUpgrade?.filter(
        (upg) => upg.status === 'inactive' && upg?.upgrade?.type === 2
      ),
    [model]
  );

  async function activeBoost() {
    try {
      const modelId = user.id;

      const upgradeToActivate = upgradeInactive[0];
      const upgradeId = upgradeToActivate.id;

      const activatedUpgrade = await UpgradesService.activeBoost({
        modelId,
        upgradeId,
      });

      console.log(activatedUpgrade);

      setModel((prev) => {
        const updatedUpgradeList = prev.modelUpgrade.filter(
          (upg) => upg.id !== activatedUpgrade.id
        );

        updatedUpgradeList.push(activatedUpgrade);

        return {
          ...prev,
          fire: prev.fire + 150,
          modelUpgrade: updatedUpgradeList,
        };
      });

      toast.success('Boost Ativo com sucesso!');
    } catch (error) {
      console.log(error);
    }
  }

  const formattedBoost = String(upgradeInactive?.length ?? 0).padStart(2, '0');
  const isActive = upgradeActive?.length > 0;

  if (loading)
    return (
      <styles.Container $show={show}>
        <Loader isLoading={loading} minimal size={60} />
      </styles.Container>
    );

  return (
    <styles.Container $show={show}>
      <styles.Rows>
        <styles.Collumn>
          <styles.Collumn>
            <styles.Group $before={backFire} $after={glassFire}>
              <styles.Background
                $before={backFire}
                $after={glassFire}
                className="fire"
              >
                <div>
                  <Text.P>Seus fogos</Text.P>
                  <Text.H1>{model?.fire}</Text.H1>
                </div>
              </styles.Background>
            </styles.Group>

            <Button
              $padding={10}
              $radius={32}
              onClick={() => navigate('/plans')}
            >
              <Text.P>Aumente seus fogos</Text.P>
            </Button>

            <Link to="/plans">
              <Text.Span>Como funcionam os foguinhos</Text.Span>
            </Link>
          </styles.Collumn>

          {upgradeInactive?.length > 0 && (
            <styles.Collumn $top={50}>
              <styles.Group $before={backBoost} $after={glassFire}>
                <styles.Background $before={backBoost} $after={glassFire}>
                  <div className="bottom">
                    <Text.P>BOOSTS DISPONÍVEIS</Text.P>
                  </div>

                  <div className="medium">
                    <Text.H1>{formattedBoost}</Text.H1>
                  </div>
                </styles.Background>

                <styles.Body>
                  {isActive && (
                    <styles.Div>
                      <small>Dados:</small>

                      <div>
                        <div>
                          <Text.H4 $bold>Ativação:</Text.H4>
                          <Text.Span>
                            {formatHoursDate(upgradeActive[0]?.startDate)}
                          </Text.Span>
                        </div>

                        <div>
                          <Text.H4 $bold>Valido Até:</Text.H4>
                          <Text.Span>
                            {formatHoursDate(upgradeActive[0]?.endDate)}
                          </Text.Span>
                        </div>
                      </div>
                    </styles.Div>
                  )}

                  <Button
                    $active={isActive}
                    $padding={10}
                    $radius={32}
                    $top={20}
                    onClick={activeBoost}
                  >
                    <Text.P $bold={isActive}>
                      {isActive ? 'Boost Ativo' : 'Ativar Boost'}
                    </Text.P>
                  </Button>

                  <button
                    type="button"
                    className="cancel"
                    onClick={() => navigate('/plans')}
                  >
                    <Text.Span>Adquirir mais Boosts</Text.Span>
                  </button>
                </styles.Body>
              </styles.Group>
            </styles.Collumn>
          )}
        </styles.Collumn>

        {model?.modelPlan && (
          <styles.Collumn>
            <styles.Group $before={backIsotipo} $after={glassIsotipo}>
              <styles.Background $before={backUpgrade} $after={glassUpgrade}>
                <div className="bottom">
                  <Text.P>SEU PLANO ATUAL</Text.P>
                </div>

                <styles.Name>
                  <Text.H3>{model?.modelPlan?.plan?.subName}</Text.H3>
                  <Text.H2>{model?.modelPlan?.plan?.name}</Text.H2>
                </styles.Name>
              </styles.Background>

              <styles.Body>
                <styles.Div>
                  <small>Dados:</small>

                  <div>
                    <div>
                      <Text.H4 $bold>Aquisição:</Text.H4>
                      <Text.Span>
                        {formatFullDate(model?.modelPlan?.startDate)}
                      </Text.Span>
                    </div>

                    <div>
                      <Text.H4 $bold>Valido Até:</Text.H4>
                      <Text.Span>
                        {formatFullDate(model?.modelPlan?.endDate)}
                      </Text.Span>
                    </div>
                  </div>

                  <div>
                    <div>
                      <Text.H4 $bold>Modalidade:</Text.H4>
                      <Text.Span $upper>Plano</Text.Span>
                    </div>

                    <div>
                      <Text.H4 $bold>Pagamento:</Text.H4>
                      <Text.Span $upper>15/08/2025</Text.Span>
                    </div>
                  </div>
                </styles.Div>

                <Button
                  $padding={10}
                  $radius={32}
                  $top={20}
                  onClick={() => navigate('/plans')}
                >
                  <Text.P>Fazer Upgrade</Text.P>
                </Button>

                <button type="button" className="cancel">
                  <Text.Span>Cancelar plano ou assinatura</Text.Span>
                </button>
              </styles.Body>
            </styles.Group>
          </styles.Collumn>
        )}

        {model?.modelUpgrade && model.modelUpgrade.length > 0 && (
          <styles.Collumn>
            <styles.Group $before={backUpgrade} $after={glassUpgrade}>
              <styles.Background $before={backUpgrade} $after={glassUpgrade}>
                <div className="bottom">
                  <Text.P>Suas melhorias</Text.P>
                </div>

                {model?.modelUpgrade
                  ?.filter(({ upgrade }) => upgrade?.type !== 2)
                  ?.map(({ upgrade }) => (
                    <styles.Name key={upgrade?.id}>
                      <Text.H2>{upgrade?.name}</Text.H2>
                      <Text.H3>{upgrade?.subName}</Text.H3>
                    </styles.Name>
                  ))}
              </styles.Background>

              <styles.Body>
                {model?.modelUpgrade
                  ?.filter(({ upgrade }) => upgrade?.type !== 2)
                  ?.map((upg) => (
                    <styles.Div key={upg.id}>
                      <small>Dados:</small>

                      <div>
                        <div>
                          <Text.H4 $bold>Aquisição:</Text.H4>
                          <Text.Span>{formatFullDate(upg?.startDate)}</Text.Span>
                        </div>

                        <div>
                          <Text.H4 $bold>Valido Até:</Text.H4>
                          <Text.Span>{formatFullDate(upg?.endDate)}</Text.Span>
                        </div>
                      </div>

                      <div>
                        <div>
                          <Text.H4 $bold>Modalidade:</Text.H4>
                          <Text.Span $upper>
                            {upg?.upgrade?.name} {upg?.upgrade?.subName}
                          </Text.Span>
                        </div>

                        <div>
                          <Text.H4 $bold>Pagamento:</Text.H4>
                          <Text.Span $upper>15/08/2025</Text.Span>
                        </div>
                      </div>

                      <button type="button" className="cancel">
                        <Text.Span>Cancelar melhoria</Text.Span>
                      </button>
                    </styles.Div>
                  ))}

                <Button
                  $padding={10}
                  $radius={32}
                  $top={4}
                  onClick={() => navigate('/plans')}
                >
                  <Text.P>Fazer Melhoria</Text.P>
                </Button>
              </styles.Body>
            </styles.Group>
          </styles.Collumn>
        )}
      </styles.Rows>
    </styles.Container>
  );
}

Plans.propTypes = {
  show: PropTypes.bool.isRequired,
};
